// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__Ads0Z","ttl":"styles_ttl__04WMS","txt":"styles_txt__r1RHl","btn":"styles_btn__EKSkB"};